import React, { useRef, useState, useEffect } from "react";
import ReactPlayer from "react-player";

const VideoSlider = React.memo(({ slides, currentIndex, goToPrevious, goToNext }) => {
  const currentSlide = slides[currentIndex];
  const playerRef = useRef(null);
  const [showPlayer, setShowPlayer] = useState(false);

  useEffect(() => {
    setShowPlayer(false);
    if (playerRef.current) {
      playerRef.current.seekTo(0);
    }
  }, [currentIndex]);

  const handleClickThumbnail = () => {
    setShowPlayer(true);
  };

  return (
    <div className="image-slider">
      <div className="slide-navigation">
        <div onClick={goToPrevious}>
          <span className="material-symbols-outlined">arrow_back</span>
        </div>
        <div className="slide-indicator">
          <div className="h4">{currentSlide.title}</div>
        </div>
        <div onClick={goToNext}>
          <span className="material-symbols-outlined">arrow_forward</span>
        </div>
      </div>

      <div className="video-container" style={{ position: "relative", width: "100%", height: "100%" }}>
        {currentSlide.type === "video" ? (
          showPlayer ? (
            <ReactPlayer
              ref={playerRef}
              url={currentSlide.videoUrl}
              controls
              playing
              width="100%"
              height="100%"
            />
          ) : (
            <div
              className="custom-preview"
              onClick={handleClickThumbnail}
              style={{
                width: '100%',
                height: '100%',
                backgroundImage: `url(${currentSlide.videoThumbnail})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
              }}
            >
              <div
                className="custom-shadow"
                style={{
                  background: 'radial-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
                  borderRadius: '64px',
                  width: '64px',
                  height: '64px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <div
                  className="custom-play-icon"
                  style={{
                    borderStyle: 'solid',
                    borderWidth: '16px 0px 16px 26px',
                    borderColor: 'transparent transparent transparent white',
                    marginLeft: '7px'
                  }}
                />
              </div>
            </div>
          )
        ) : (
          <img
            src={currentSlide.imageUrl}
            alt={currentSlide.title}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        )}
      </div>
    </div>
  );
});

export default VideoSlider;